import { default as MenuButtonComponent } from "~/components/Header/Buttons/Menu";
import { default as FloatingSearchButtonComponent } from "~/components/search/FloatingSearchButton";
import type { Props as FloatingSearchButtonProps } from "~/components/search/FloatingSearchButton";

export function MenuButton() {
  return <MenuButtonComponent />;
}

export function FloatingSearchButton(props: FloatingSearchButtonProps) {
  return <FloatingSearchButtonComponent {...props} />;
}
